/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ monthlyPrice: NonNullable<unknown>, yearlyPrice: NonNullable<unknown> }} Dialog_Premium_PricingInputs */

const en_dialog_premium_pricing = /** @type {(inputs: Dialog_Premium_PricingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It's ${i?.monthlyPrice}/mo or ${i?.yearlyPrice}/year. Cancel any time, no commitment.`)
};

const es_dialog_premium_pricing = /** @type {(inputs: Dialog_Premium_PricingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Son ${i?.monthlyPrice}/mes o ${i?.yearlyPrice}/año. Cancela en cualquier momento, sin compromiso.`)
};

/**
* | output |
* | --- |
* | "It's {monthlyPrice}/mo or {yearlyPrice}/year. Cancel any time, no commitment." |
*
* @param {Dialog_Premium_PricingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_pricing = /** @type {((inputs: Dialog_Premium_PricingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_PricingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_pricing(inputs)
	return en_dialog_premium_pricing(inputs)
});